<!-- 平台账号管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" type="warning" @click="goModal">新增账号</Button>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="title">
                        <div>{{ row.relation.length ? row.relation[0].group.title : '' }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1">正常</div>
                        <div v-if="row.status == 0">禁用</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(row)">编辑</Button>
                            <Button v-if="row.status == 1" type="warning" ghost label="small" @click="changeStatus(row)">禁用</Button>
                            <Button v-if="row.status == 0" type="success" ghost label="small" @click="changeStatus(row)">启用</Button>
                            <Button type="error" ghost label="small" @click="goDel(row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="mt-24 ta-r">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal v-model="modals" :title="modalTitle" width="500" :mask-closable="false">
            <div>
                <Form ref="formData" :model="formData" label-position="right" :label-width="100" :rules="ruleValidate">
                    <FormItem label="账户名称：" prop="user">
                        <Input type="text" v-model="formData.user" placeholder="请输入账户名称"></Input>
                    </FormItem>
                    <FormItem label="手机号：" prop="phone">
                        <Input type="text" v-model="formData.phone" placeholder="请输入手机号"></Input>
                    </FormItem>
                    <FormItem label="密码：" prop="password">
                        <Input type="password" password v-model="formData.password" placeholder="请输入密码"></Input>
                    </FormItem> 
                    <FormItem label="分配角色：" prop="group">
                        <CheckboxGroup v-model="formData.group" v-for="(item, index) in roleList" :key="index">
                            <Checkbox :label="item.id + ''"><span>{{item.title}}</span></Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button class="theme-bg ml-24" type="warning" @click="submitForm">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    account_list, 
    account_save, 
    account_status, 
    account_delete,
} from '@/api/index';
import { 
    account_roles_select,
} from '@/api/select';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "账户名称", key: "user", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "角色名称", slot: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "300px" },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formData: {
                id: "",
                user: "",
                password: "",
                phone: "",
                group: [],
            },
            ruleValidate: {
                user: [
                    { required: true, message: '请输入账户名称', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            },
            roleList: [],
        };
    },
    mounted() {
        this.getList();
        this.getAccountRolesSelect();
    },
    methods: {
        getList(){
            account_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index){
            this.storePrams.page = index;
            this.getList();
        },
        getAccountRolesSelect(){
            account_roles_select().then((res) => {
                this.roleList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // Modal
        goModal(row){
            if(row.id){
                this.modalTitle = "编辑账号";
                this.formData.id = row.id;
                this.formData.user = row.user;
                this.formData.phone = row.phone;
                this.formData.group = row.group;
            }else {
                this.modalTitle = "新增账号";
                this.formData.id = "";
                this.formData.user = "";
                this.formData.password = "";
                this.formData.phone = "";
                this.formData.group = [];
            }
            this.modals = true;
        },
        cancelForm(){
            this.modals = false;
        },
        // 确定（提交表单）
        submitForm(){
            if(!this.formData.group.length){
                this.$Message.error('请选择分配角色');
                return
            }
            const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if(!phoneReg.test(this.formData.phone)){
                this.$Message.error('请输入正确的手机号码');
                return
            }
            account_save(this.formData).then( res => {
                this.getList();
                this.modals = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 修改账户状态
        changeStatus(row){
            let that = this;
            this.$Modal.confirm({
                title: '修改提示',
                content: '确认修改账户状态吗？',
                onOk: () => {
                    account_status({ id:row.id }).then(res=>{
                        that.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
        goDel(row){
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    account_delete({ id:row.id }).then(res=>{
                        that.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox{
    margin-right: 12px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>